import React, { useEffect, useState } from "react";
import { MdClose } from "react-icons/md";
import { getApiCaller } from "../../../../Libs/apiCaller";
import { FadeLoader } from "react-spinners";
import { toast } from "react-toastify";

const NewProfileModal = ({ isOpen, onClose, onSave }) => {
  const [selectedAvatar, setSelectedAvatar] = useState("");
  const [isLaoding, setIsLaoding] = useState(false);
  const [allAvatar, setAllAvatar] = useState([]);

  useEffect(() => {
    if (isOpen) {
      getAvatar();
    }
  }, [isOpen]);

  const getAvatar = async () => {
    setIsLaoding(true);
    const endPoint = "users/avtar";
    const response = await getApiCaller(endPoint);

    if (response?.status === 200) {
      setAllAvatar(response.data.avatars);
    } else {
      toast.error(response?.response?.data?.message || response.message);
    }
    setIsLaoding(false);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white w-full max-w-2xl p-6 rounded-lg relative shadow-lg">
        <button
          onClick={() => {
            setSelectedAvatar("");
            onClose();
          }}
          className="absolute top-5 right-2 text-gray-500 hover:text-black"
        >
          <MdClose size={24} />
        </button>
        <h2 className="text-xl font-semibold mb-4">Avatar profile photo</h2>
        {isLaoding && (
          <div className="h-[auto] content-center justify-items-center mb-6">
            <FadeLoader color="#7104F8" loading={true} size={12} />
          </div>
        )}
        {!isLaoding && (
          <>
            <div className="pt-5 flex flex-col items-center justify-center mx-auto">
              <img
                src={selectedAvatar.avtarImage ? selectedAvatar.avtarImage : allAvatar[0]?.avtarImage}
                alt="Profile Preview"
                className="w-[130px] h-[130px] object-cover rounded-4xl  "
              />
              <p className="text-[#7C7C7C] my-4 mt-6">Choose avatar</p>
            </div>

            <div className="grid grid-cols-5 gap-5 mt-5 h-60 overflow-y-auto">
              {allAvatar.map((avatar, index) => (
                <img
                  key={index}
                  src={avatar.avtarImage}
                  alt={`Avatar ${index + 1}`}
                  onClick={() => setSelectedAvatar(avatar)}
                  className={`w-[100px] h-[100px] mb-5 object-cover rounded-full cursor-pointer transition-all duration-200 ${
                    selectedAvatar === avatar
                      ? "border-2 border-dashed border-[var(--primary-color)]"
                      : "border border-transparent"
                  }`}
                />
              ))}
            </div>

            <button
              onClick={() => {
                onSave(selectedAvatar);
                onClose(); // Close modal
              }}
              className="btn btn-primary bg-[var(--primary-color)] w-fit mt-5 px-10 text-white rounded-full ml-auto block"
            >
              Save
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default NewProfileModal;
